module.exports = __webpack_public_path__ + "img/card.44bbffe2.svg";